module.exports = __webpack_public_path__ + "static/media/07.d80a5687.png";